import React, { useEffect, useState, useRef } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { makeStyles, CardContent, Card } from '@material-ui/core';
import { useHistory } from 'react-router';
import axios from 'axios';
import Select from '@material-ui/core/Select';
import FormControl from '@material-ui/core/FormControl';
import InputLabel from '@material-ui/core/InputLabel';
import Grid from '@material-ui/core/Grid';
import Typography from '@material-ui/core/Typography';
import moment from 'moment';
import Table from './table/Table';
import { setSelectedImc } from '../services/store/actions/index';
import { CommonConfig } from '../../config/common-config';
import SearchBox from '../../components/table/SearchBox';

const useStyles = makeStyles((theme) => ({
    root: {
        flexGrow: 1,
    },
    paper: {
        padding: theme.spacing(3),
        textAlign: 'center',
        color: theme.palette.text.secondary,
    },
    intHeading: {
        color: '#31333f',
        fontFamily: 'Rubik',
        fontWeight: '700',
        fontSize: '30px',
    },
    imcNo: {
        fontWeight: '700',
        color: '#f8961d',
    },
    colorFnt: {
        color: '#ef8400',
        paddingBottom: theme.spacing(4),
    },
    noRecord: {
        display: 'flex',
        justifyContent: 'center',
        background: '#f6f6f6',
        margin: '16px',
        '& h1': {
            alignSelf: 'center',
            color: 'grey',
            fontFamily: 'Rubik',
            fontSize: '14px',
            fontWeight: '400',
        },
    },
}));

export default function LongOpenClients() {
    const dispatch = useDispatch({});
    const myRef = useRef();
    const [searchQuery, setSearchQuery] = useState('');
    const [AllImcs, setAllImcs] = useState([]);
    const [selectedImc, setselectedImc] = useState('');
    const [page, setPage] = useState(0);
    const [pageDetails, setPageDetails] = useState('');
    const [loading, setLoading] = useState(false);
    const [previousButton, setpreviousButton] = useState(false);
    const [nextButton, setnextButton] = useState(false);
    const [rows, setOpenService] = useState([]);
    const tempToken = useSelector((state) => state.loginsuccessreducer.loggedInUserDetails.result);
    const userToken = tempToken && tempToken.data.token;
    const bearerToken = `Bearer ${userToken}`;
    const axiosConfig = {
        headers: {
            Authorization: bearerToken,
        },
    };
    const tennantName = useSelector((state) => state.serviceCheckListReducer.imcNameSelected);
    const triggerUseEffect = useSelector((state) => state.serviceCheckListReducer.triggerUseEffect);
    const userDetails = useSelector((state) => state.loginsuccessreducer.loggedInUserDetails);
    //const usertype = userDetails.result && userDetails.result.data.userType;
    const userTeam = userDetails.result && userDetails.result.data.features[0].team;
    const userDomain = userDetails.result && userDetails.result.config.data;

    useEffect(() => {
        axios
            .get(`${CommonConfig.dev.baseUrl}/api/auth/s-int-clients`, {
                headers: {
                    Authorization: bearerToken,
                },
            })
            .then((response) => {
                setAllImcs(response.data.content);
            })
            .catch((error) => {
                //console.log(error);
            });
        if (selectedImc) {
            getCandidates();
        }
        if (userTeam != 'ITeC Team') {
            if (userDomain) {
                let JsonUserDomain = JSON.parse(userDomain);
                setselectedImc(JsonUserDomain.tennantName);
                dispatch(setSelectedImc(JsonUserDomain.tennantName));
                getCandidates();
                setPage(0);
            }
        }
    }, [selectedImc, page, triggerUseEffect]);
    const classes = useStyles();

    const scrollTop = () => {
        myRef.current.scrollIntoView();
    };
    const setImc = (e) => {
        // alert(e.target.value);
        setselectedImc(e.target.value);
        dispatch(setSelectedImc(e.target.value));
        getCandidates();
        setPage(0);
    };

    const clearField = () => {
        setSearchQuery('');
        setPage(0);
        if (selectedImc) {
            getCandidates();
        }
        if (userTeam != 'ITeC Team') {
            if (userDomain) {
                let JsonUserDomain = JSON.parse(userDomain);
                setselectedImc(JsonUserDomain.tennantName);
                dispatch(setSelectedImc(JsonUserDomain.tennantName));
                getCandidates();
                setPage(0);
            }
        }
    }

    const allImcsOptions = (vv) => {
        const OptionList = vv.map((data) => (
            <option value={data.dbName} key={data.dbName}>
                {data.dbName}
            </option>
        ));
        return OptionList;
    };

    const headcells = [
        { id: 'serviceId', label: 'Service ID' },
        { id: 'clientId', label: 'Client ID' },
        // { id: 'clientName', label: 'Name' },
        { id: 'servicetypeId', label: 'Service type', isConcat: 'true', concatElem: ['servicetypeText'] },
        { id: 'statusId', label: 'Current status', isConcat: 'true', concatElem: ['statusText'] },
        { id: 'statusId', label: 'Date at this stage', isConcat: 'true', concatElem: ['dateModified'] },
    ];

    const handleCount = (val) => {
        if (val === 'prev') {
            if (pageDetails.first !== true) {
                setPage((page) => page - 1);
            }
        }

        if (val === 'next') {
            if (pageDetails.last !== true) {
                setPage((page) => page + 1);
            }
        }
    };

    const getCandidates = () => {
        setLoading(true);
        setpreviousButton(true);
        setnextButton(true);
        let apiUrl = `${CommonConfig.dev.baseUrl}/api/auth/long-open-services/${selectedImc}?page=${page}&size=10&sort=serviceId,desc`;
        axios
            .get(apiUrl, axiosConfig)
            .then((response) => {
                //console.log('response', response.data);
                scrollTop();
                formatDate(response.data.content);
                setOpenService(response.data.content);
                setPageDetails(response.data);
                setLoading(false);
                if (response.data.first) {
                    setpreviousButton(true);
                    setnextButton(false);
                } else if (response.data.last) {
                    setpreviousButton(false);
                    setnextButton(true);
                } else {
                    setpreviousButton(false);
                    setnextButton(false);
                }
            })
            .catch((error) => {
                //console.log(error);
            });
    };
    function formatDate(props) {
        return props.map((element) => {
            element.dateModified = moment(element.dateModified).format('DD-MM-YYYY');
        });
    }

    // handle search item
    const handleSearchQuery = (data) => {
        //console.log(data);
        setSearchQuery(data);
        // filterData(data);
    };

    // Search through nested objects
    const filteredRow = searchQuery
        ? rows.filter((searchRow) => {
            const query = searchQuery.toLowerCase().trim();
            //   ////console.log(Object.keys(row) ,"Keys of ROW**** object.keys()");
            return headcells
                .map((col) => col)
                .some((key) => {
                    //   ////console.log(key, 'from inside some');

                    if (key.isConcat && searchRow[key.id]) {
                        //console.log("Search Row",searchRow);
                        const subdata = searchRow[key.id];
                        //console.log(subdata,"subData");
                        const mergedData = key.concatElem.map((concatdata) => {
                            //console.log(concatdata,"concatData");
                            return concatdata.split('.').reduce((acc, item) => {
                                //   ////console.log(acc ,item,"Acc item from reduce")
                                if (Object.prototype.hasOwnProperty.call(acc, item)) {
                                    if (typeof acc[item] !== 'object') {
                                        return acc[item].toString().toLowerCase().includes(query);
                                    }
                                    return acc[item];
                                }
                                return false;
                            }, subdata);
                        });
                        //console.log(mergedData,"mergeData");

                        return mergedData[0];
                    }
                    return searchRow[key.id].toString().toLowerCase().includes(query);
                });
        })
        : rows;

    return (
        <div className={classes.root} ref={myRef}>
            {userTeam === 'ITeC Team' ? (
                <CardContent>
                    <Grid spacing={3} className="main-container" style={{ width: '40%' }}>
                        <Grid item xs={12} sm={12} style={{ paddingLeft: '0' }}>
                            <FormControl fullWidth>
                                <InputLabel className="lbl" htmlFor="selectimc" shrink>
                                    Select IMC
                                </InputLabel>
                                <Select native className="bottom" name="intclientName" onChange={setImc} value={selectedImc}>
                                    <option value="" selected disabled hidden>
                                        Select IMC
                                    </option>
                                    {allImcsOptions(AllImcs)}
                                </Select>
                            </FormControl>
                        </Grid>
                    </Grid>
                </CardContent>
            ) : (
                    ''
                )}
            <Card className="custom-table">
                <CardContent className="card-title-display">
                    <Grid item xs={12} sm={8}>
                        <Typography className="card-title">Long open Clients</Typography>
                    </Grid>
                    <Grid item xs={12} sm={6} className="card-search">
                        <div className="search-field">
                            <SearchBox searchQuery={searchQuery} onChange={handleSearchQuery} clearField={clearField} placeholder="Search..." />
                        </div>
                    </Grid>
                </CardContent>
                <CardContent className="card-table-display">
                    {rows && filteredRow.length > 0 ? (
                        <>
                            <Table
                                headCells={headcells}
                                rows={filteredRow}
                                action
                                handleCount={handleCount}
                                pageDetails={pageDetails}
                                loading={loading}
                                prvnxtbt={{ prvBt: previousButton, nxtBt: nextButton }}
                                axiosConfig={axiosConfig}
                                tennantName={tennantName}
                            />
                        </>
                    ) : (
                            <div className={classes.noRecord}>
                                <h1>No records to display</h1>
                            </div>
                        )}
                </CardContent>
            </Card>
        </div>
    );
}
